import {OfferType, ShowcaseContext} from "../models/OfferPageDto";
import {
    OfferApiResponse,
    OfferApiResponseFunctionalError,
    OfferApiResponseSuccess,
    OfferApiResponseTechnicalError
} from "../models/OfferApiResponse";

declare const $: any;

export class OfferService {
    private static readonly API_URLS = {
        INTERNET_OFFER: '/api/internet/offre/{seoId}?',
        MOBILE_OFFER: '/api/mobile/offre/{seoId}?'
    };

    /**
     * Récupère le détail d'une offre via son SEO ID
     */
    static getOffer(
            seoId: string,
            deviceSeoId: string | null,
            showcaseContext: ShowcaseContext,
            offerType: OfferType
    ): Promise<OfferApiResponse> {

        let url = "";
        if (offerType == OfferType.INTERNET) {
            url = this.API_URLS.INTERNET_OFFER.replace('{seoId}', seoId);
        } else {
            url = this.API_URLS.MOBILE_OFFER.replace('{seoId}', seoId);
        }

        const params: Record<string, string> = deviceSeoId ? {
            mode: showcaseContext.toString(),
            device: deviceSeoId
        } : { mode: showcaseContext.toString() };

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url + $.param(params),
                method: "GET",
                xhrFields: {withCredentials: true},
                crossDomain: true,
                contentType: "application/json",
                success: (response: OfferApiResponseSuccess) => {
                    resolve(response);
                    const dataLayer = response.showcaseDatalayerInfos;
                    if (dataLayer) {
                        //@ts-expect-error : on surcharge o_data pour qu'il soit à jour avec le dataLayer de l'offre
                        window.o_data = {...dataLayer};
                        //@ts-expect-error : Tms est chargé lors de l'import du tms.js, il ne faut pas le réimporter
                        Tms.view(dataLayer);
                    }
                },
                error: (xhr: any) => {
                    this.handleApiError(xhr, reject);
                }
            });
        });
    }

    /**
     * Gère les erreurs des appels API et effectue une redirection si nécessaire
     */
    private static handleApiError(xhr: any, reject: (reason?: any) => void): void {
        const errorData =
                (xhr.responseJSON as OfferApiResponseFunctionalError | OfferApiResponseTechnicalError) || null;

        if (errorData?.redirectUrl) {
            window.location.href = errorData.redirectUrl;
            reject({redirecting: true});
        } else {
            reject({
                status: xhr.status
            });
        }
    }
}

export function isOfferApiResponseSuccess(response: OfferApiResponse): response is OfferApiResponseSuccess {
    return 'offer' in response;
}
